import { Modal } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import {
  AutomaticPaymentRemindersType,
  useAutomaticPaymentRemindersModalForm,
} from '@features/invoicingSettings/modules/paymentsAndReminders'

import { AutomaticPaymentRemindersModalBody } from './elements/AutomaticPaymentRemindersModalBody'
import { AutomaticPaymentRemindersModalFooter } from './elements/AutomaticPaymentRemindersModalFooter'

interface AutomaticPaymentRemindersModalComponentProps {
  modalId: string
}

export const AutomaticPaymentRemindersModalComponent = ({
  modalId,
}: AutomaticPaymentRemindersModalComponentProps): ReactElement => {
  const { t } = useTranslation()
  const { variant } = useAutomaticPaymentRemindersModalForm()

  const automaticPaymentRemindersModalHeaderTitle = useMemo(() => {
    return {
      [AutomaticPaymentRemindersType.AfterDueDate]: t(
        'settings.organization.external_invoice.automatic_payment_reminders.modal.after_due_date.title',
      ),
      [AutomaticPaymentRemindersType.BeforeDueDate]: t(
        'settings.organization.external_invoice.automatic_payment_reminders.modal.before_due_date.title',
      ),
      [AutomaticPaymentRemindersType.OnDueDate]: t(
        'settings.organization.external_invoice.automatic_payment_reminders.modal.on_due_date.title',
      ),
    }
  }, [t])

  const modalTitle = automaticPaymentRemindersModalHeaderTitle[variant]

  return (
    <>
      <Modal.Header title={modalTitle} closable id={modalId} />
      <AutomaticPaymentRemindersModalBody variant={variant} />
      <AutomaticPaymentRemindersModalFooter id={modalId} />
    </>
  )
}
